import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters({
      services: "service/services",
    }),
  },
  methods: {
    ...mapMutations({
      SET_SELECTED_SERVICE: "service/SET_SELECTED_SERVICE",
      SET_SELECTED_ORDER_SERVICEID: "order/SET_SELECTED_SERVICEID",
      RESET_ORDER: "order/RESET_ORDER",
    }),
    ...mapActions({
      setUuid: "order/setUuid",
      setComplexitykeysinfo: "order/setComplexitykeysinfo",
    }),

    editOrder(order) {
      const service = this.services.find((item) => {
        return item.id === order.service.id;
      });
      this.SET_SELECTED_SERVICE(service);
      this.SET_SELECTED_ORDER_SERVICEID(service.id);
      this.RESET_ORDER();
      this.setUuid({
        uuid: order.token,
      });
      service.complexities.map((complexity) => {
        this.setComplexitykeysinfo(complexity);
      });
      this.$router.push({
        name: "step-one",
        params: { slug: service.slug },
        query: { order: order.id },
      });
    },
  },
};
